import type { Role } from '@/shared/api';

import type { RouteName } from './paths';

/**
 * Wie welk scherm mag openen, in één tabel voor de router (`RequireRole` in
 * `AppRouter.tsx`) en de rail (`layouts/nav-model.ts`). Zo kan de rail nooit
 * een link tonen waar de router je meteen weer vandaan stuurt.
 *
 * Een scherm dat hier niet staat, is er voor iedereen die in een bedrijf werkt.
 * Een platformbeheerder komt overal binnen (`hasRole`).
 */
export const OFFICE_ROLES = ['owner'] as const satisfies readonly Role[];

export const FIELD_ROLES = ['inspector'] as const satisfies readonly Role[];

export const PLATFORM_ROLES = ['platform_admin'] as const satisfies readonly Role[];

export const routeRoles = {
    myDay: FIELD_ROLES,
    planning: OFFICE_ROLES,
    billing: OFFICE_ROLES,
    settings: OFFICE_ROLES,
} as const satisfies Partial<Record<RouteName, readonly Role[]>>;
